interface UnloggedCardProps {
  children: React.ReactNode;
}

export const UnloggedCard = ({ children }: UnloggedCardProps) => {
  return (
    <div className="w-[95%] max-w-[500px] bg-neutral-0 p-8 rounded-lg shadow-md">
      {children}
    </div>
  );
};
